import { SourcingEventStatus, SourcingEventDto } from "../../../autogen/bff-api";
import { hasTenderStageQualification } from "../../sourcing-events/buyer/wizard/utils/procedure";

export type CompetitionStage = "INTEREST_OPEN" | "REQUESTS_OPEN" | "QUALIFICATION" | "TENDERING";

// Both values are derived server-side from the qualification round and the server clock —
// the single source of truth. Never re-derive stage or deadline from raw eventData fields:
// for two-stage events the tilbudsfrist lives on the invitation, not in eventData.
export const competitionStage = (event: SourcingEventDto): CompetitionStage | null =>
  (event.competitionStage as CompetitionStage | undefined) ?? null;

export const effectiveBidDeadline = (event: SourcingEventDto): string | null =>
  event.milestoneDates?.bidSubmissionDeadline ?? null;

export const publishedBidDeadline = (event: SourcingEventDto): string | null =>
  event.announcedBidSubmissionDeadline ?? effectiveBidDeadline(event);

// Same rule for the forespørselsfrist: it is frozen onto the qualification round when the contract
// notice is dispatched (BT-1311), and eventData keeps only the editable draft the wizard binds to.
// Reading eventData alone blanks the deadline out on every dispatched two-stage procurement.
export const effectiveRequestDeadline = (event: SourcingEventDto): string | null => {
  const publicContext = event.eventContext.type === "Public" ? event.eventContext : null;
  return (
    publicContext?.qualificationRound?.requestDeadline ??
    event.milestoneDates?.plannedRequestDeadline ??
    event.eventData.requestDeadline ??
    null
  );
};

// In a single-stage procedure «fullfør kvalifisering» is what opens the evaluation, so the
// Evaluering tab stays locked while the event is still PUBLISHED (SM-867).
export const isEvaluationLocked = (event: SourcingEventDto): boolean =>
  event.status === SourcingEventStatus.Published &&
  hasTenderStageQualification(
    event.eventContext.type === "Public" ? event.eventContext.procedureType : undefined,
  );
